module.exports = __webpack_public_path__ + "media/audio35.ce52d169.mp3";